import React, { useContext, useEffect, useState } from "react";

import { put } from "../../util/fetch.js";
import Button from "../button/ButtonController.jsx";
import { NotificationItem } from "./NotificationItem.jsx";
import { GlobalContext } from "../../globals/globalContext.jsx";
import { useNotificationTranslation } from "./useNotificationTranslation.jsx";
import "./styles.styl";

export default function Notifications({ onSuccess }) {
  const { subscription, setSubscription } = useContext(GlobalContext);
  const auto_buy = subscription.auto_buy;
  const [formState, setFormState] = useState({
    proposal: subscription.receive_proposal_email,
    reminder: subscription.receive_reminder_email,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [notificationsErrorMessage, setNotificationsErrorMessage] =
    useState("");
  const {
    autoBuyNotificationText,
    saveSettingsText,
    orderWindowEmailText,
    reminderEmailtext,
  } = useNotificationTranslation();

  const autobuyNotification = auto_buy ? autoBuyNotificationText : "";
  const NOTIFICATION_ITEMS = [
    {
      description: orderWindowEmailText,
      id: "suggestion-notification",
      key: "proposal",
    },
    {
      description: reminderEmailtext,
      id: "reminder-notification",
      key: "reminder",
    },
  ];

  const handleChange = (currentItem) => {
    setFormState((prev) => ({
      ...prev,
      [currentItem]: !prev[currentItem],
    }));
  };

  function handleSubmit() {
    setNotificationsErrorMessage("");
    setIsLoading(true);

    subscriptionNotificationsUrl = `${location.origin}/api/subscriptions/${subscription.id}/notifications`;
    const body = {
      receive_proposal_email: formState.proposal,
      receive_reminder_email: formState.reminder,
    };
    put(subscriptionNotificationsUrl, { body })
      .then((resp) => {
        setSubscription((prevSubscription) => ({
          ...prevSubscription,
          receive_proposal_email: resp.receive_proposal_email,
          receive_reminder_email: resp.receive_reminder_email,
        }));

        onSuccess && onSuccess();
      })
      .catch((error) => {
        setNotificationsErrorMessage(
          error.data?.reason || "An unexpected error occurred.",
        );
        setIsLoading(false);
      });
  }

  function getSaveSettingsText() {
    return `${isLoading ? "... " : ""}${saveSettingsText}${
      isLoading ? " ..." : ""
    }`;
  }

  return (
    <>
      <div className="notifications">
        {NOTIFICATION_ITEMS.map((notificationItem) => (
          <NotificationItem
            key={notificationItem.key}
            notificationItem={notificationItem}
            defaultChecked={formState[notificationItem.key]}
            handleChange={handleChange}
            auto_buy={auto_buy}
          />
        ))}
        <div>
          <p className="error">{notificationsErrorMessage}</p>
          <p className="info">{autobuyNotification}</p>
        </div>
      </div>
      <div style={{ marginTop: "2.5rem" }}>
        <Button onClick={handleSubmit} disabled={auto_buy}>
          {auto_buy ? (
            <span style={{ color: "black" }}>{saveSettingsText}</span>
          ) : (
            <>{getSaveSettingsText()}</>
          )}
        </Button>
      </div>
    </>
  );
}
